// extracted by mini-css-extract-plugin
export default {"root":"HomePage_root__9Dcrw","bg":"HomePage_bg__cyN3K"};